import { toast } from 'react-toastify';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import * as actions from './Actions';
import * as api from './Api';
import Types from './Types';

function* getAllSubjectAssistPhones({ payload }) {
    try {
        yield put(actions.addSubjectAssistPhonesLoading(true));
        const result = yield call(api.getAllSubjectAssistPhones);
        // Handle both direct array response or wrapped in data property
        const data = Array.isArray(result.data) ? result.data : (result.data?.data || result.data || []);
        yield put(actions.getAllSubjectAssistPhonesSuccess({ data }));
    } catch (error) {
        const { response, message } = error;
        toast.error(error?.response?.data?.message || 'Failed to fetch assistant phones');
        yield put(actions.getAllSubjectAssistPhonesFail());
    } finally {
        yield put(actions.addSubjectAssistPhonesLoading(false));
    }
}

//Edit SubjectAssistPhone
function* editSubjectAssistPhone(data) {
    try {
        yield put(actions.addSubjectAssistPhonesLoading(true));
        const result = yield call(api.editSubjectAssistPhone, data.payload);
        // API returns { status, message, data }
        // Extract data and wrap in { data: ... } for reducer
        const phoneData = result.data?.data || result.data;
        if (phoneData) {
            yield put(actions.editSubjectAssistPhoneSuccess({ data: phoneData }));
            toast.success(result.data?.message || 'Edit Successfully');
            data?.action && data?.action();
        } else {
            throw new Error('Invalid response structure');
        }
    } catch (error) {
        yield put(actions.editSubjectAssistPhoneFail());
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to update assistant phone';
        toast.error(errorMessage);
    } finally {
        yield put(actions.addSubjectAssistPhonesLoading(false));
    }
}

// create
function* createSubjectAssistPhone(formData) {
    try {
        yield put(actions.addSubjectAssistPhonesLoading(true));
        const result = yield call(api.createSubjectAssistPhone, formData.payload);
        yield put(
            actions.createSubjectAssistPhoneSuccess({
                data: result.data
            })
        );
        toast.success('Created Successfully');
        formData?.action && formData?.action()
    } catch (error) {
        yield put(actions.createSubjectAssistPhoneFail());
        toast.error(error?.response?.data?.message || 'Failed to create assistant phone');
    } finally {
        yield put(actions.addSubjectAssistPhonesLoading(false));
    }
}

function* deleteSubjectAssistPhone({ payload }) {
    try {
        yield put(actions.addSubjectAssistPhonesLoading(true));
        const result = yield call(api.deleteSubjectAssistPhone, payload);

        yield put(actions.deleteSubjectAssistPhoneSuccess(payload));

        toast.success('Deleted Successfully');
    } catch (error) {
        const { response, message } = error;
        toast.error(error?.response?.data?.message || 'Failed to delete assistant phone');
        yield put(actions.deleteSubjectAssistPhoneFail());
    } finally {
        yield put(actions.addSubjectAssistPhonesLoading(false));
    }
}

export default function* SubjectAssistPhoneSaga() {
    yield takeLatest(Types.GET_SUBJECT_ASSIST_PHONES_REQUEST, getAllSubjectAssistPhones);
    yield takeLatest(Types.EDIT_SUBJECT_ASSIST_PHONE_REQUEST, editSubjectAssistPhone);
    yield takeLatest(Types.CREATE_SUBJECT_ASSIST_PHONE_REQUEST, createSubjectAssistPhone);
    yield takeLatest(Types.DELETE_SUBJECT_ASSIST_PHONE_REQUEST, deleteSubjectAssistPhone);
}

